import { render, staticRenderFns } from "./ps-seri.vue?vue&type=template&id=203007f6&lang=html&"
import script from "./ps-seri.vue?vue&type=script&lang=js&"
export * from "./ps-seri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports